module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Black.240b25faec5549c0e4622bfd6b4ccb8e.woff2";